import flatpickr from 'flatpickr';
import axios from 'axios';

export default function deliveryDate() {
	if (document.querySelectorAll('.delivery-date')) {
		let picker = document.querySelectorAll('.delivery-date');

		if (picker) {
			axios
				.get('https://www.gov.uk/bank-holidays.json')
				.then(function (response) {
					// grab bank holidays from gov website
					let bankHolidays = [];
					response.data['england-and-wales'].events.forEach(function (
						e,
						i
					) {
						var bd = new Date(e.date);
						if (bd.getHours() == 1) {
							bd.setHours(0);
						}
						// 2011-10-10T14:48:00
						bankHolidays.push(
							Date.parse(
								bd.getFullYear() +
									'-' +
									('0' + (bd.getMonth() + 1)).slice(-2) +
									'-' +
									('0' + bd.getDate()).slice(-2) +
									'T00:00:00'
							)
						);
					});

					picker.forEach(function (el, ind) {
						let minDateDays = 0;
						let min = 3;
						let now = new Date();

						now = Date.parse(
							now.getFullYear() +
								'-' +
								('0' + (now.getMonth() + 1)).slice(-2) +
								'-' +
								('0' + now.getDate()).slice(-2) +
								'T00:00:00'
						);

						for (let i = 0; i < min; i++) {
							// friday = 5, saturday = 6, sunday = 0
							let day = new Date().fp_incr(minDateDays).getDay();
							if (
								(i == 0 &&
									(day == 5 || bankHolidays.includes(now))) ||
								day == 6 ||
								day == 0
							) {
								min++;
							}
							minDateDays++;
						}

						for (let i = 1; i < minDateDays + 1; i++) {
							if (
								bankHolidays.includes(
									new Date().fp_incr(i).getTime()
								)
							) {
								minDateDays++;
							}
						}

						let minDate = new Date().fp_incr(minDateDays);

						const fp = flatpickr(el, {
							dateFormat: 'd M Y',
							minDate: minDate,
							disable: [
								function (date) {
									// return true to disable
									return (
										date.getDay() === 0 ||
										date.getDay() === 6 ||
										bankHolidays.includes(date.getTime()) ||
										// grundon festive dates 24th Dec - 4rd Jan (inclusive)
										(date.getMonth() === 11 &&
											[
												24, 25, 26, 27, 28, 29,
												30, 31,
											].includes(date.getDate())) ||
										(date.getMonth() === 0 &&
											[1, 2, 3].includes(
												date.getDate()
											)) ||
										// adhock date removal
										(date.getFullYear() === 2024 &&
											date.getMonth() === 4 &&
											[29].includes(date.getDate()))
									);
								},
							],
							locale: {
								firstDayOfWeek: 1, // start week on Monday
							},
						});
					});
				})
				.catch(function (error) {
					// handle error
					console.log(error);

					picker.forEach(function (el, ind) {
						const fp = flatpickr(el, {
							dateFormat: 'd M Y',
							minDate: new Date().fp_incr(3),
							disable: [
								function (date) {
									// return true to disable
									return (
										date.getDay() === 0 ||
										date.getDay() === 6 ||
										// grundon festive dates 24th Dec - 3rd Jan (inclusive)
										(date.getMonth() === 11 &&
											[
												24, 25, 26, 27, 28, 29, 30, 31,
											].includes(date.getDate())) ||
										(date.getMonth() === 0 &&
											[1, 2, 3].includes(
												date.getDate()
											)) ||
										// adhock date removal
										(date.getFullYear() === 2024 &&
											date.getMonth() === 4 &&
											[29].includes(date.getDate()))
									);
								},
							],
							locale: {
								firstDayOfWeek: 1, // start week on Monday
							},
						});
					});
				});
		}
	}
}
